export default __webpack_public_path__ + "static/media/team.9e62b591.jpg";